// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"MerchantDisclaimer_disclaimer__mgbAx","link":"MerchantDisclaimer_link__awjZz","block":"MerchantDisclaimer_block__oJwIs"};